module.exports = __webpack_public_path__ + "static/citybikes-f15c4128f73ddc4655df70eda6892233.png";